const helpContents = require('./help/')
const articles = require('./articles')

module.exports = {

	common: {
		noun: {
			time: "Time",
			amount: "Amount",
			balance: 'Balance',
			price: "Price",
			allowance: "Allowance",
			errors: "Error(s)",
			maker: "Maker",
			taker: "Taker",
			buyer: "Buyer",
			makerFee: "Maker Fee",
			takerFee: "Taker Fee",
			protocolFee: "Protocol Fee",
			block: "Block",
			makerToken: "Maker Token",
			takerToken: "Taker Token",
			makerTokenAmount: "Maker Token Amount",
			takerTokenAmount: "Taker Token Amount",
			orderStatus: "Status",
			orderAmountFilled: "Amount Filled",
			orderAmountAvailable: "Amount Available",
			fillable: "Fillable",
			relayer: "Relayer",
			max: "Max",
			amountFillable: "Fillable",
			language: "Language",
			me: "Me",
			notification: "notification",
			timePeriod: {
				'minutes': 'Minutes',
				'hours': 'Hours',
				'days': 'Days',
				'weeks': 'Weeks',
				'months': 'Months',
				'years': 'Years',
			},
			version: "Version",
		},
		verb: {
			sell: "Sell",
			buy: "Buy",
			haveSent: "Sent",
			haveReceived: "Received",
			reset: "Reset",
			cancel: "Cancel",
			tryAgain: "Try Again",
			check: "Check",
			checkAgain: "Check Again",
			checking: "Checking",
			adding: "Adding",
			removing: "Removing",
			close: "Close",
			clear: "Clear",
			select: "Select",
		},
		phrase: {
			setAllowance: "Set Allowance",
			addNewToken: "Add New Token",
			noOrderFound: "No Order Found",
			noRecentTrade: "No Recent Trade",
			viewOrder: "View Order",
			fillOrder: "Fill Order",
			cancelOrder: "Cancel Order",
			deleteOrderRecord: "Delete Record",
			learnMore: "Learn More",
			visitOldVersion: "Visit Old Version",
			fieldIsRequired: "This field is required",
			loading: "Loading...",
			viewDetails: "View Details",
			whatsNew: "What's New",
		},
		token: {
			name: "Name",
			symbol: "Symbol",
			decimals: "Decimals",
			address: "Address",
		},
		orderForm: {
			label: {
				tokenToSell: "Token to Sell",
				tokenToBuy: "Token to Buy",
				amountToSell: "Amount to Sell",
				amountToBuy: "Amount to Buy",
				amountToFill: "Amount to Fill",
				whoCanFill: "Who Can Fill This Order",
				takerAccount: "Account to Fill This Order",
				expirationTime: "Order Expires",
				enterPriceAs: "Enter Price As",
				now: "Now",
			},
			option: {
				whoCanFill: {
					anybody: "Anybody can fill this order",
					selected: "Only selected account can fill this order",
				}
			},
		},
		err: {
			generic: "Sorry, an error occurred. You can try reloading the page to try again.",
			amount: {
				max: "Max",
				mustNumber: "Must be a number",
				mustGreaterThanZero: "Should be greater than 0",
				insufficientBalance: "Insufficient balance",
				insufficientAllowance: "Insufficient allowance",
				tooManyDecimals: "Too many decimal places",
				maxValCanFill: "Max value you can fill: "
			},
			address: {
				addMissing: "Please enter an account address",
				invalidAdd: "Invalid address",
				ownAdd: "This is your own account",
			},
			time: {
				mustBeFuture: "Must be a time in the future",
			},
		},
	},

	nav: {
		home: "Home",
		about: "About",
		aboutLedgerDex: "About LedgerDex",
		terms: "Terms",
		unkownNetwork: "Unknown Network",
		myTokens: "My Tokens",
		marketplace: "Marketplace",
		createNewOrder: "Create New Order",
		help: "Help",
		trade: "Trade",
		myOrders: "My Orders",
		ordersForMe: "Orders for Me",
		tradeHistory: "Trade History",
		login: "Log In",
		logout: "Logout",
		darkMode: "Dark Mode",
		orderDetails: "Order Details",
		fillJsonOrder: "Fill Order Using JSON Code",
	},

	compPendingTx: {
		intro: "Transaction submitted to network. It might take some time to finish and you don't have to wait.",
		btnViewTx: "View Transaction",
	},

	compWrap: {
		title: "Wrap ETH",
		labelAmount: "Amount to convert:",
		btnConvert: "Convert ETH to WETH",
		btnConvertLoading: "Converting, please wait",
		successMessage: "{amount} ETH has been converted to WETH successfully.",
	},

	compUnwrap: {
		title: "Unwrap WETH",
		labelAmount: "Amount to convert:",
		btnConvert: "Convert WETH to ETH",
		btnConvertLoading: "Converting, please wait",
		successMessage: "{amount} WETH has been converted to ETH successfully.",
	},

	compSetAllowance: {
		titleSet: "Set Allowance",
		titleRemove: "Remove Allowance",
		introSet: "In order for our smart contract to execute your trades, you need to give our smart contract permission to access your tokens. This permission is called \"allowance\".",
		confirmRemove: 'Are you sure you want to remove allowance for {tokenSymbol} ?',
		buttonTextSet: 'Set Allowance',
		buttonTextRemove: 'Remove Allowance',
		buttonTextSetting: 'Setting allowance, please wait',
		buttonTextRemoving: 'Removing allowance, please wait',
		successSetMessage: "Allowance has been set for {tokenSymbol} successfully.",
		successRemoveMessage: "Allowance has been removed for {tokenSymbol} successfully.",
	},

	compAddTokenTracking: {
		title: "Add New Token",
		optSelectTitle: "Select from Verified tokens",
		optSelectIntro: "Below are some verified ERC20 tokens you can choose from.",
		optSelectNoMore: "You have already added all verified tokens. To add unverified tokens, please use the token searching feature to find and add.",
		optSearchTitle: "Search Token to Add",
		optSearchLabel: "Enter ERC20 Token's Contract Address:",
		optSearchTxtExample: "Example",
		btnTxtAddToken: "Add Token",
		btnTxtAddingToken: "Adding token, please wait",
		btnTxtSearchToken: "Search Token",
		btnTxtSearchingToken: "Searching",
		optSearchResultNotFoundTxt: "Token not found or invalid (not a valid ERC20 token). Please check the address and try again.",
		optSearchResultFoundTitle: "Token Found",
		optSearchResultFoundAgreement: "I have checked the token myself and will take full responsibility if there's any problem with this token.",
		searchErrInvalidAddress: "Invalid Address",
		searchErrAlreadyAdded: "You have already added this token",
		successMessage: "Token {tokenSymbol} has been added successfully.",
	},

	compRemoveTokenTracking: {
		title: "Remove Token",
		txtConfirm: "Are you sure you want to stop tracking this token?",
		txtCanAddBack: "You can add it back later if you want.",
		btnStopTracking: "Stop Tracking Token",
		btnStopTrackingLoading: "Stopping, please wait",
		successMessage: "You have successfully stopped tracking token {tokenSymbol}.",
	},

	compSendToken: {
		title: "Send Token",
		intro: "Send {tokenSymbol}",
		labelRecipientAdd: "Recipient Address:",
		labelAmount: "Amount to Send",
		btnSend: "Send",
		btnSending: "Sending, please wait",
		successMessage: "{tokenAmount} of {tokenSymbol} has been sent successfully.",
	},

	compUserAddress: {
		you: "You",
	},

	compNewOrderForm: {
		introTxt: "To sell a token, you must own that token and need to set allowance for that token first. If your desired token is not listed below, you can add it on the \"My Tokens\" page.",
		reviewOrder: "Review Order",
		btnModifyOrder: "Modify Order",
		btnSubmitOrder: "Submit Order",
		btnSubmitOrderLoading: "Submitting order, please wait",
		successMessageShowJSON: "You order has been successfully generated and cryptographically signed. Below is the JSON code that summarizes your order.",
		btnViewOrder: "View YOrder",
		btnViewOrderList: "View Your Orders",
		btnCreateAnotherOrder: "Create Another Order",
		successMessageShort: "Your order has been signed and submitted successfully.",
		err: {
			tokenShouldBeDifferent: "Token to sell and token to buy should be different",
			noToken: "You don't have this token available.",
			noAllowance: "You don't have allowance for this token.",
			orderUnfillable: "This order is not fillable.",
		},
	},

	compOrderSummary: {
		orderNotFound: "Order Not Found",
		showJsonCode: "Show JSON Code",
		yourOwnOrder: "Your Own Order",
		youCannotFill: "You Can't Fill This Order",
		tokenAmountFilled: "{tokenSymbol} Filled",
		tokenAmountAvailable: "{tokenSymbol} Available",
		estimatedProtocolFee: "Protocol Fee (Estimated)",
		makerPay: "Maker Pay",
		takerPay: "Taker Pay",
		youPay: "You Pay",
		unfillableReason: {
			ORDER_UNFILLABLE: "This order is not fillable",
			Invalid: "This order is invalid",
			InvalidMakerAssetAmount: "This order's maker amount is invalid",
			InvalidTakerAssetAmount: "This order's taker amount is invalid",
			Expired: "This Order has already expired",
			FullyFilled: "This Order has been filled",
			Cancelled: "This Order has been cancelled",
			OWN_ORDER: "This is your own order",
			NOT_TAKER: "You are not the taker specified in this order",
			INSUFFICIENT_TAKER_ASSET: "Your don't have enough {tokenSymbol} token to fill this order",
			INSUFFICIENT_TAKER_ALLOWANCE: "Your don't have enough allowance for the {tokenSymbol} token to fill this order",
		},
		btnFillOrder: "Fill Order",
		btnFillOrderLoading: "Filling order, please wait",
		statusWaitingMatamask: "Waiting for MetaMask. Please approve transaction on MetaMask.",
		statusSuccess: "You have successully filled the order!",
		btnViewTradeHistory: "View Your Trade History",
		statusFailed: "Transaction failed",
		cancelOrder: {
			areYouSure: "Are you sure you want to cancel this order so that it will no longer be fillable by other traders? (You will need to pay Gas fee.)",
			doNotCancel: "No, Don't Cancel",
			yesCancel: "Yes, Cancel Order",
			cancelLoading: "Cancelling Order",
		},
		deleteOrder: {
			areYouSure: "Are you sure you want to delete record for this order? (You do not need to pay Gas fee.)",
			doNotDelete: "No, Don't Delete",
			yesDelete: "Yes, Delete Order Record",
			deleteLoading: "Deleting",
		},
	},

	compTradeSummary: {
		exChangeFeeYouPaid: "Trading Fee(s) You Paid",
		btnViewDetails: "View Details",
	},

	compOrdersByTokenPair: {
		popularTradingPairs: "Popular Trading Pairs",
		myWatchlist: "My Watchlist",
		addNewTradingPair: "Add New Trading Pair",
		watched: "Watched",
		notWatched: "Not Watched",
		removeFromWatchlist: "Remove from Watchlist",
		addToWatchlist: "Add to Watchlist",
		createOrder: "Create Order",
		liveData: "Live Data",
		noAskOrder: "No Ask Orders",
		spread: "SPREAD",
		noBidOrder: "No Bid Orders",
	},

	compSimpleOrderSummary: {
		btnFillOrder: "Fill {tokenSymbol}",
		yourOrder: "Your Order",
	},

	compAddTokenPairWatchForm: {
		title: "Add New Token Pair to Watchlist",
		btnAdd: "Add Trading Pair",
		btnAddLoading: "Adding trading pair, please wait",
		successMessage: "{tokenPair} has been addded to your watchlist successfully."
	},

	compPublicFooter: {
		subscribeNewsletter: "Subscribe Newsletter",
	},

	compLogInWatcher: {
		logOutWarning: {
			title: "Log Out Warning",
			intro: "Your current login section will expire in {time} minutes.",
			btnKeepLoggedIn: "Keep Me Logged In",
		}
	},

	feedbackForm: {
		introTxt: "Have questions, feedback or suggestions? Please email us:",
		buttonTxt: "Contact Us",
	},

	loginPage: {
		title: "LOG IN",
		connectWallet: "Connect Wallet",
		connectMetaMask: "Connect MetaMask",
		introConnectMetaMask: "To use LedgerDex, please connect MetaMask first.",
		introConnectMobileWallet: "To use LedgerDex, please connect you wallet first.",
		connectMetaMaskError: "Could not connect to MetaMask. Please try again.",
		connectWalletError: "Could not connect to wallet. Please try again.",
		loginError: "Login failed. Please try again.",
		preloaderMessage: "Taking too long? Please make sure MetaMask is connected and please approve our connect request if asked!",
		metaMaskFullName: "MetaMask browser extension",
		txtNeedMobileWallet: "To use LedgerDex, you need to visit this page from a compatible mobile wallet.",
		txtNeeedMataMask1: "To use this web app, you need to install the ",
		txtNeeedMataMask2: ", which is supported by following web browsers: Chrome, FireFox, Opera and Brave.",
		txtWrongNetwork: "Sorry, you're connected to an unsupported Ethereum network. Currently we support the following network(s):",
		txtLoginMetamaskFirst: "To use this web app, plese log in your web browser's MetaMask extension first.",
		txtAccessDenied: "You have rejected our access request on MetaMask. Without your approval of access, you cannot use this platform.",
		txtAccessRetry: "Try Again",
		txtPleaseSignMetaMask: "To log in, simply use MetaMask to sign the login message. No need for registering an account. No password needed.",
		txtPleaseSignWallet: "To log in, simply use your wallet to sign the login message. No need for registering an account. No password needed.",
		txtAgreeTermsFront: "I agree with LedgerDex's ",
		TermsAndConditions: "Terms and Conditions",
		buttonTxtLoggingIn: "Logging In",
		buttonTxtLogInUsingMetaMask: "Log In Using MetaMask",
		buttonTxtLogInUsingWallet: "Log In Using Wallet",
		titleLocationBanned: "Service Not Available in {country}",
		txtLocationBanned: "Based on your IP address, you are visiting us from: {country}. Sorry, our service is not available to people living in this country/region.",
		txtLocationBanBypassAgreement: "I confirm that I do not live in {country}. I would like to use your service.",
		buttonByPassLocationBan: "Proceed to Use LedgerDex",
	},

	myTokensPage: {
		myAccount: "My Account",
		popularTokens: "Popular Tokens",
		trackedTokens: "Tracked Tokens",
		tableTitleToken: "Token",
		tableTitleBalance: "Balance",
		tableTitleAllowance: "Allowance",
		tableTitleOrders: "Search Orders",
		tableTitleManage: "Manage",
		buttonTxtWrap: "Wrap",
		buttonTxtUnwrap: "Unwrap",
		buttonTxtBuyOrders: "Buy Orders",
		buttonTxtSellOrders: "Sell Orders",
		buttonTxtActions: "Actions",
		instantBuy: "Buy",
		actionTxtBuy: "Create Order: Buy",
		actionTxtSell: "Create Order: Sell",
		actionTxtSetAllowance: "Set Allowance",
		actionTxtRemoveAllowance: "Remove Allowance",
		actionTxtStopTracking: "Stop Tracking",
		actionTxtSend: "Send",
		tooltipTxtAllowance: "In order for the smart contract to execute your trades, you need to give the smart contract access permission to your tokens by setting allowance.",
		tooltipTxtWrapUnWrap: "ETH cannot be traded with other tokens directly. You need to wrap it (convert it to WETH) first. WETH can be converted back to ETH (unwrapped) at any time.",
		tooltipTxtClickToSetAllowance: "Click to Set Allowance",
		tooltipTxtClickToRemoveAllowance: "Click to Remove Allowance",
	},

	ERC20TokenPage: {
		title: "Token",
		titleManage: "Manage",
		titleWrapUnwrap: "ETH Wrapping",
		titleTrade: "Trade",
		titleMarketplace: "Marketplace",
		titleTokenTracking: "Token Tracking",
		btnAddTokenTracking: "Add Tracking",
		btnRemoveTokenTracking: "Remove Tracking",
		titlePopularSellOrders: "Popular Sell Orders",
		titlePopularBuyOrders: "Popular Buy Orders",
		titleMoreSellOrders: "More Sell Orders",
		titleMoreBuyOrders: "More Buy Orders",
		titleActiveTradingPairs: "Active Trading Pairs",
		titleTrackedTradingPairs: "Tracked Trading Pairs",
		displayNone: "None"
	},

	parseJsonOrderPage: {
		txtIntro: "Please paste the JSON code for a order below:",
		err: {
			invalidJson: "Invalid JSON code",
		}
	},

	instantBuyTokenPage: {
		title: 'Instant Buy',
		tokenNotFound: 'Sorry, token not found.',
		introTxt: 'This is a quick way to buy ERC20 tokens, powered by <strong><a href="https://0x.org/instant" target="_blank">0x Instant</a></strong>. You can buy tokens with Ether (ETH) directly. There\'s no need for wrapping Ether or setting allowance.',
		tokenNotAvailableForBuying: 'Sorry, this token is not available for buying at this moment.',
		notAvailableForInstant: 'Instant Buy Not Available',
		pleaseVerifiyToken: 'Please verify the token info before buying:',
		btnTxtBuy: 'Instant Buy',
	},

	helpContents,

	articles,

}


